module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleClose),
      expression: "handleClose"
    }],
    staticClass: "el-select",
    class: [_vm.selectSize ? 'el-select--' + _vm.selectSize : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleMenu.apply(null, arguments)
      }
    }
  }, [(_vm.multiple) ? _c('div', {
    ref: "tagsRef",
    staticClass: "el-select__tags",
    style: ({
      'max-width': _vm.inputWidth - 32 + 'px',
      width: '100%',
      opacity: 0,
      'pointer-events': 'none'
    })
  }, [(_vm.collapseTags && _vm.selected.length) ? _c('span', _vm._l((_vm.selected), function(item, index) {
    return _c('rt-tag', {
      key: index,
      staticClass: "rt-tag-box",
      attrs: {
        "size": "medium",
        "disabled": _vm.computedDisabled,
        "closable": !_vm.computedDisabled,
        "type": "fill"
      }
    }, [_vm._v(_vm._s(item.currentLabel) + "\n      ")])
  }), 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.multiple) ? _c('div', {
    ref: "tags",
    staticClass: "el-select__tags",
    style: ({
      'max-width': _vm.inputWidth - 32 + 'px',
      width: '100%',
      'flex-wrap': 'nowrap'
    }),
    on: {
      "mouseenter": _vm.multipleTagsMouseenterHandler,
      "mouseleave": _vm.multipleTagsMouseleaveHandler
    }
  }, [(_vm.collapseTags && _vm.selected.length) ? _c('span', [_vm._l((_vm.selected.slice(0, _vm.maxSelectedNum)), function(item, index) {
    return _c('rt-tag', {
      key: index,
      ref: "multipleTag",
      refInFor: true,
      attrs: {
        "disabled": _vm.computedDisabled,
        "closable": !_vm.computedDisabled,
        "type": "fill",
        "size": "medium"
      },
      on: {
        "close": function($event) {
          return _vm.deleteTag($event, item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.currentLabel) + "\n      ")])
  }), _vm._v(" "), (_vm.selected.length > _vm.maxSelectedNum) ? _c('rt-tooltip', {
    attrs: {
      "content": _vm.maxSelectedContent,
      "placement": "bottom"
    }
  }, [_c('rt-tag', {
    attrs: {
      "disabled": _vm.computedDisabled,
      "closable": false,
      "type": "fill",
      "size": "medium"
    }
  }, [_vm._v("\n          + " + _vm._s(_vm.selected.length - _vm.maxSelectedNum) + "\n        ")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.collapseTags) ? _c('transition-group', {
    on: {
      "after-leave": _vm.resetInputHeight
    }
  }, _vm._l((_vm.selected), function(item) {
    return _c('rt-tag', {
      key: _vm.getValueKey(item),
      attrs: {
        "disabled": _vm.computedDisabled,
        "closable": !_vm.computedDisabled,
        "type": "fill",
        "size": "medium"
      },
      on: {
        "close": function($event) {
          return _vm.deleteTag($event, item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item[_vm.alias.name]) + "\n      ")])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.filterable) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "input",
    staticClass: "el-select__input",
    class: [_vm.selectSize ? ("is-" + _vm.selectSize) : ''],
    style: ({
      'flex-grow': '1',
      width: _vm.inputLength / (_vm.inputWidth - 32) + '%',
      'max-width': _vm.inputWidth - 42 + 'px',
      border: 'none',
      paddingLeft: 0,
    }),
    attrs: {
      "disabled": _vm.selectDisabled,
      "autocomplete": _vm.autoComplete || _vm.autocomplete,
      "type": "text"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": function($event) {
        _vm.softFocus = false
      },
      "click": function($event) {
        $event.stopPropagation();
      },
      "keyup": _vm.managePlaceholder,
      "keydown": [_vm.resetInputState, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.navigateOptions('next')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.navigateOptions('prev')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.selectOption.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        _vm.visible = false
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        return _vm.deletePrevTag.apply(null, arguments)
      }],
      "compositionstart": _vm.handleComposition,
      "compositionupdate": _vm.handleComposition,
      "compositionend": _vm.handleComposition,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.debouncedQueryChange]
    }
  }) : _vm._e()], 1) : (_vm.isPicklist) ? _c('div', {
    staticClass: "el-select__tags",
    style: ({
      'max-width': _vm.inputWidth - 32 + 'px',
      width: '100%',
      'flex-wrap': 'nowrap',
    }),
    on: {
      "mouseenter": _vm.multipleTagsMouseenterHandler,
      "mouseleave": _vm.multipleTagsMouseleaveHandler
    }
  }, [(_vm.computedNonEmptyTagValue) ? _c('rt-tag', {
    ref: "singleTag",
    attrs: {
      "type": "fill",
      "size": "medium",
      "max-width": _vm.inputWidth - 44
    }
  }, [_vm._v("\n      " + _vm._s(_vm.tagValue) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.computedNonEmptyTagValue && _vm.filterable) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    staticClass: "el-select__input",
    class: [_vm.selectSize ? ("is-" + _vm.selectSize) : ''],
    style: ({
      'flex-grow': '1',
      width: _vm.inputLength / (_vm.inputWidth - 32) + '%',
      'max-width': _vm.inputWidth - 42 + 'px',
      border: 'none',
      paddingLeft: 0,
      minWidth: 16 + 'px',
    }),
    attrs: {
      "autocomplete": _vm.autoComplete || _vm.autocomplete,
      "disabled": _vm.selectDisabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.radioValue)
    },
    on: {
      "focus": _vm.handleFocus,
      "click": function($event) {
        $event.stopPropagation();
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.navigateOptions('next')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.navigateOptions('prev')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.selectOption.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        _vm.visible = false
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        return _vm.deletePrevTag.apply(null, arguments)
      }],
      "blur": _vm.handleRadioBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.radioValue = $event.target.value
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-input', {
    ref: "reference",
    class: {
      'is-focus': _vm.visible,
      'is-hover': _vm.inputIsHover
    },
    attrs: {
      "id": _vm.id,
      "placeholder": _vm._computedPlaceholder,
      "name": _vm.name,
      "autocomplete": _vm.autoComplete || _vm.autocomplete,
      "size": _vm.selectSize,
      "disabled": _vm.selectDisabled,
      "readonly": _vm.readonly,
      "validate-event": false,
      "type": "text"
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.debouncedOnInputChange.apply(null, arguments)
      },
      "keydown": [function($event) {
        return _vm.handleKeydown.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.navigateOptions('next')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.navigateOptions('prev')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.selectOption.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        _vm.visible = false
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        _vm.visible = false
      }],
      "paste": function($event) {
        return _vm.debouncedOnInputChange.apply(null, arguments)
      },
      "mouseenter": function($event) {
        _vm.inputHovering = true
      },
      "mouseleave": function($event) {
        _vm.inputHovering = false
      }
    },
    model: {
      value: (_vm.selectedLabel),
      callback: function($$v) {
        _vm.selectedLabel = $$v
      },
      expression: "selectedLabel"
    }
  }, [(_vm.$slots.prefix) ? _c('template', {
    slot: "prefix"
  }, [_vm._t("prefix")], 2) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "suffix"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showClose),
      expression: "!showClose"
    }],
    class: [
      'el-select__caret',
      'el-input__icon',
      'el-icon-' + _vm.iconClass
    ]
  }), _vm._v(" "), (_vm.showClose) ? _c('i', {
    staticClass: "el-select__caret el-input__icon el-icon-circle-close",
    on: {
      "click": _vm.handleClearClick
    }
  }) : _vm._e()])], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    },
    on: {
      "before-enter": _vm.handleMenuEnter,
      "after-leave": _vm.doDestroy
    }
  }, [_c('el-select-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible && _vm.emptyText !== false),
      expression: "visible && emptyText !== false"
    }],
    ref: "popper",
    attrs: {
      "append-to-body": _vm.popperAppendToBody
    }
  }, [_c('el-scrollbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.options.length > 0 && !_vm.loading),
      expression: "options.length > 0 && !loading"
    }],
    ref: "scrollbar",
    class: {
      'is-empty': !_vm.allowCreate && _vm.query && _vm.filteredOptionsCount === 0
    },
    attrs: {
      "tag": "ul",
      "wrap-class": "el-select-dropdown__wrap",
      "view-class": "el-select-dropdown__list"
    }
  }, [(_vm.showNewOption) ? _c('el-option', {
    attrs: {
      "value": _vm.query,
      "created": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (
    _vm.emptyText &&
    (!_vm.allowCreate || _vm.loading || (_vm.allowCreate && _vm.options.length === 0))
  ) ? [(_vm.$slots.empty) ? _vm._t("empty") : _c('p', {
    staticClass: "el-select-dropdown__empty"
  }, [_vm._v("\n          " + _vm._s(_vm.emptyText) + "\n        ")])] : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6ce5e12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/select/src/select.vue
// module id = 2218
// module chunks = 137